var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6787 29.25C15.1644 29.25 10.6981 24.8869 10.6981 19.5C10.6981 14.1131 15.1644 9.75 20.6787 9.75C25.6192 9.75 29.7196 13.2681 30.5097 17.875H40.5652C39.7169 7.865 31.1418 0 20.6787 0C9.65842 0 0.717407 8.73437 0.717407 19.5C0.717407 30.2656 9.65842 39 20.6787 39C31.1418 39 39.7169 31.135 40.5652 21.125H30.5097C29.7196 25.7319 25.6192 29.25 20.6787 29.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.c055c986a5acd2adf92cf98e3622b6e3.svg";
export { ForwardRef as ReactComponent };